import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={"https://drive.google.com/file/d/1ltVVQZxAIHWoCdnuIRElDq-_Ho004Dy7/view?usp=sharing"} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Research Experience</h3>
            <Resumecontent
              title="Person Re-identification Work Under Dr. Pratik Chhatopadhyay (IIT BHU) and Nirbhay Tagore (Phd. IIT BHU)"
              date="Feb 2021 - July 2021"
              content={[
                "Working on developing a novel way to tackle the challenges in Person-Re-identification for unconstrained images and videos"
              ]}
              name = " To know more about Pratik Sir visit - "
              link1 = "https://www.iitbhu.ac.in/dept/cse/people/pratikcse"
              link2 = "https://sites.google.com/site/pratikchattopadhyay/research"
              site1 = "Profile"
              mediator = "and"
              site2 = "Google Site"
            />
            <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Event Coordinator [SIC-2020 and 2021 An event at Social Fest, Jagriti of IIT BHU]"
              content={[
                "Worked in Management of Social Innovation Challenge (SIC) via Online platform efficiently for two succesive years in hard times of Covid-19",
                "The event witnessed ideas from different IIMs, NITs, Schools etc."
              ]}
            />
            <Resumecontent
              title="Event Co-Coordinator [Continum, Analog Based Event at UDYAM 2021, ECE Dept. Fest of IIT BHU]"
              content={[
                "This competition deals with finding methods which solves problems concrened with real and practical situations using Op-amps and other analog devices",
                "Helped the participants in getting over installation and concepts related doubts."
              ]}
            />
            <Resumecontent
              title=" Worked as Freelance Content writer [for Collegedunia from May 2020-July 2020]"
              content={[
                "Worked in Writing Articles related to different Educational things like College comparison, Degrees Orders/Importance etc...",
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="Electronics Engineering [Indian Institute of Technology Varanasi, Uttar pradesh, India] "
              date="2019 - Present"
              content={[`CGPA/GPA: 9.26 (Till 3rd Sem)`]}
            />
            <Resumecontent
              title="12TH BOARD [Akash Model Sr. Sec. School, New Delhi]"
              date="Completed in 2019"
              content={["Precentage: 95.2%"]}
            />
            <Resumecontent
              title="10TH BOARD [Bal Sthali Sec. School, New Delhi] "
              date="Completed in 2017"
              content={["CGPA: 10"]}
            />
            <h3 className="resume-title">Achievements</h3>
            <Resumecontent
              title=""
              content={[
                "1st Position at event Cassandra, A Data Science event organised by UDYAM'21(Departmental fest of Electronics Eng, IIT BHU)",
                "2nd Position at event Recognizance, AN ML+DL event organised by Prastuti'21(Departmental fest of Electrical Eng, IIT BHU)",
                "Selected Under Top-10 Finalists from All over India in Hyundai H-Social Creatorz 2021 for Project Winnovation",
                "Presented Project SMA at Social Conclave in 10th InterIIT TechMeet organised by IIT Guwahati",
                "Successfully Cleared Upto the Hardware Round of E-yantra Robotics Competition, 2021",
                "Best First yearite for the event Continum at UDYAM 2020", 
                "Cleared College Round of Smart India Hackathon (SIH-2020) in Hardware Section for proposing a cost effective mechanism to treat waste water in Small Villages."

              ]}
            />
            <h3 className="resume-title">Posts and PORs</h3>
            <Resumecontent
              title=""
              content={[
                "Joint Secretary of Social Projects' Club, IIT BHU (from August 2020 - April 2021)",
                "Member of RoboREG(Robotics REsearch Group) at IIT BHU.",
                "Member of COPS ML Group, IIT BHU"
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={"https://drive.google.com/file/d/1ltVVQZxAIHWoCdnuIRElDq-_Ho004Dy7/view?usp=sharing"} target="_blank">
          <AiOutlineDownload />&nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
